import firebase from "firebase/app";
import "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDWMugRYmc8LpfocovWdDjeOPlyoilajSg",
  authDomain: "mybook-jobs.firebaseapp.com",
  databaseURL: "https://mybook-jobs.firebaseio.com",
  projectId: "mybook-jobs",
  storageBucket: "mybook-jobs.appspot.com",
  messagingSenderId: "144489434370",
  appId: "1:144489434370:web:f9729059ac167ab19c461b",
};

// firebase.initializeApp(firebaseConfig);

const lazy = fn => {
  let isLoaded = false;
  let result;
  return () => {
    if (!isLoaded) {
      isLoaded = true;
      result = fn();
    }
    return result;
  };
};

const db = lazy(() => {
  firebase.initializeApp(firebaseConfig);
  return firebase.firestore();
});

export default db;
